export const LIMIT_DEFAULT = 50;
export const P_SERVICE_LIMIT_DEFAULT = 6;

export const ENTITIES = {
    categories: '/data/categories',
    cities: '/items/cities',
    cityTranslations: '/items/city_translations',
    companies: '/items/companies',
    countryTranslations: '/items/country_translations',
    docPolicies: '/items/doc_policies',
    documents: '/items/documents',
    eventTagTranslations: '/items/tag_translations',
    eventTranslations: '/items/event_translations',
    eventTypes: '/items/event_types',
    events: '/data/events',
    filterPresets: '/items/filter_presets',
    googleStatistics: '/items/google_stats',
    languages: '/items/languages',
    language_translations: '/items/language_translations',
    links: 'links',
    partners: '/items/partners',
    promotedEvents: '/data/promoted_events',
    seatSchema: '/items/seat_schemas',
    tags: '/items/tags',
    tickets: '/items/tickets',
    users: '/users',
    services: '/data/services',
    service_translations: '/items/service_translations',
    purchase_transactions: '/items/purchase_transactions',
};

export const locationIdOnline = '7698a716-269f-41a5-9e31-8f4988fdb4f1';

[{ category: { _eq: 'Novel' } }, { section: { _eq: 'Adults' } }];
